/**
 * Registers `/keys` with the ops router (`src/ops/routes/index.ts`'s
 * glob) -- the only file in this area anything outside it imports.
 *
 * Plain `createElement` calls, not JSX: this file is `.ts`, matching every
 * other area's registration file (`../prices/routes.ts`,
 * `../register/routes.ts`), and the glob itself is pinned to the literal
 * `routes.ts` extension -- JSX syntax needs `.tsx`, which the glob would not
 * see. The page's own body, with its dialog-open state, lives in `Keys.tsx`.
 */

import { createElement } from 'react';
import { Link } from 'lucide-react';

import type { OpsRouteBundle } from '../routes/contract';
import { OpsShell } from '../shell/OpsShell';
import { opsTitles } from '../shell/titles';
import { Keys } from './Keys';

export const bundle: OpsRouteBundle = {
  order: 50,
  routes: [
    { path: '/keys', element: createElement(OpsShell, null, createElement(Keys)), kind: 'data' },
  ],
  // Figma 153:342: the sidebar row's own icon is "link", not the key-round
  // icon the page content uses for a single provider key.
  nav: [{ path: '/keys', label: () => opsTitles.t('keys'), icon: Link, kind: 'data' }],
};
